import OurFeesCompensationTable from "./OurFeesCompensationTable";
import type { OurFeesCompensationTableAdapterProps, CompensationListProps } from "./OurFeesCompensationTable.d";

export { OurFeesCompensationTable };
export type { OurFeesCompensationTableAdapterProps, CompensationListProps };
